module.exports = __webpack_public_path__ + "static/media/Redshield.254f6970.webp";